import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import ko from 'date-fns/locale/ko'
import { useCookies } from 'react-cookie'

import serverController from 'server/serverController'
import { formatDate } from 'utils/utils.js'

import MyTaskListHeader from 'components/containers/task/MyTaskListHeader'
import TaskListNavBar from 'components/containers/task/TaskListNavBar'
import AchivementBlock from 'components/containers/task/AchivementBlock'
import TodoList from 'components/containers/task/TodoList'
import TaskListFeed from 'components/containers/feed/TaskListFeed'
import Calendar from 'components/containers/calendar/Calendar'

import arrowDown from 'images/icon/arrow_down-13x50.png'
import addRoutineBtn from 'images/icon/plus_gray_icon-48×48.png'
import certificationBtnChangeImg from 'images/event/certification_btn_change_img-412×170.png'

// 투두리스트 아이콘 누르면 나오는 페이지
export default function MyTaskListLayout({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const [cookies, setCookie] = useCookies()

  const [displayCalendar, setDisplayCalendar] = useState(false)
  const [isTodoListLoading, setIsTodoListLoading] = useState(false)
  const [isTodoListLoadingEnd, setIsTodoListLoadingEnd] = useState(false)
  const [todoList, setTodoList] = useState([])

  const [reloadAchivement, setReloadAchivement] = useState(false)
  const [userdata, setUserdata] = useState({})
  const [todoListRelation, setTodoListRelation] = useState(null)

  const [selectDay, setSelectDay] = useState(null)
  // const [todoListRelation, setTodoListRelation] = useState(null);
  const [deletedTodoListItem, setDeletedTodoListItem] = useState(null)
  const [displayTodoList, setDisplayTodoList] = useState(false)

  const [currBar, setCurrBar] = useState('validate')
  const initNavBar = [
    { data: 'validate', txt: '인증', currTab: true },
    { data: 'feed', txt: '피드' },
    { data: 'calendar', txt: '캘린더' },
  ]
  const [navBarList, setNavBarList] = useState(initNavBar)
  const [currTask, setCurrTask] = useState(null)

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let date = match.params.date
    if (date) {
      setSelectDay(new Date(date))
    } else {
      setSelectDay(new Date(formatDate()))
    }
  }, [])

  useEffect(() => {
    if (currBar !== 'calendar') {
      setDisplayCalendar(false)
      setSelectDay(new Date(formatDate()))
    } else {
      setSelectDay(null)
    }
  }, [currBar])

  useEffect(() => {
    if (userInfo['isLogin'] === true) {
      serverController.getServerData(`users/${userInfo['id']}`, infoCallBack)
      setTodoListRelation('self')
    } else {
      setTodoListRelation('guest')
    }
  }, [])

  useEffect(() => {
    if (selectDay === null) {
      setDisplayTodoList(false)
    }
    if (selectDay !== null && userInfo['isLogin'] === true) {
      updateTasks()
    }
  }, [selectDay])

  const infoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      console.log('???')
      alert('예기치 못한 오류가 발생하였습니다.')
      return
    }
    const achievementGoalChars = jsonData.data.user.achievement_goal
    if (achievementGoalChars !== null && achievementGoalChars.trim() === '') {
      jsonData.data.user.achievement_goal = null
    }
    setUserdata(jsonData.data.user)
  }

  const updateTasks = () => {
    // setIsTodoListLoading(true)
    // setIsTodoListLoadingEnd(false)
    setIsTodoListLoading(true)
    setIsTodoListLoadingEnd(false)
    serverController.getServerData(`tasks/dates/${formatDate(selectDay)}/todolist`, (res) => {
      setTodoListDataCallback(res)
      setIsTodoListLoading(false)
      setIsTodoListLoadingEnd(true)
    })
  }
  const setTodoListDataCallback = (res) => {
    // setIsTodoListLoading(false)
    // setIsTodoListLoadingEnd(true)
    if (res.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.')
      return
    }

    let jsonData = res.data
    if (jsonData['todolist']) {
      setTodoList(jsonData['todolist'])
    }
  }

  const handleEditResult = (e) => {
    updateTasks()
    setReloadAchivement(true)
  }

  const handleDeleteTodoList = (deletedItem) => {
    setDeletedTodoListItem(deletedItem.task.task_date)
    updateTasks()
    setReloadAchivement(true)
  }

  let currSelectedData = null
  if (currBar === 'calendar' && displayCalendar === true) {
    currSelectedData = [
      <div
        key={'main-calendar-component'}
        style={{ position: 'relative', height: '100%', overflowY: 'hidden' }}
      >
        <CalendarWrapper>
          <Calendar
            selectDay={selectDay}
            setSelectDay={setSelectDay}
            deletedTodoListItem={deletedTodoListItem}
            setDeletedTodoListItem={setDeletedTodoListItem}
            userNo={userInfo['id']}
          />
        </CalendarWrapper>

        <TodoListWrapper
          isOpen={selectDay ? true : false}
          onTransitionEnd={(e) => {
            e.persist()
            if (selectDay) {
              setDisplayTodoList(true)
            }
          }}
        >
          <TodoListHeader>
            <TodoListCloseBtnBlock onClick={() => setSelectDay(null)}>
              <TodoListCloseBtn>
                <TodoListCloseBtnImg src={arrowDown} />
              </TodoListCloseBtn>
            </TodoListCloseBtnBlock>
            <TodoListHeaderTxt>{`${format(
              selectDay ? selectDay : new Date(),
              'MM월 dd일 (EEEEEE)',
              { locale: ko },
            )}`}</TodoListHeaderTxt>
          </TodoListHeader>
          {displayTodoList ? (
            <TodoList
              currentDate={selectDay ? selectDay : new Date()}
              setCurrentDate={setSelectDay}
              todoList={todoList}
              setTodoList={setTodoList}
              userNo={userInfo['id']}
              disableCalendar={true}
              userRelation={todoListRelation}
              onEdit={handleEditResult}
              onDeleteResult={handleDeleteTodoList}
              isLoading={isTodoListLoading}
              isLoadingEnd={isTodoListLoadingEnd}
            />
          ) : null}
        </TodoListWrapper>
      </div>,
    ]
  } else if (currBar === 'feed') {
    currSelectedData = [
      <TaskListFeed
        key={'main-feed-component'}
        onEdit={() => {
          updateTasks()
          setReloadAchivement(true)
        }}
        onDelete={() => {
          updateTasks()
          setReloadAchivement(true)
        }}
        userNo={userInfo['id']}
      />,
    ]
  } else if (currBar === 'validate') {
    currSelectedData = [
      <React.Fragment key={'main-todolist-component'}>
        <TodoList
          currentDate={selectDay ? selectDay : new Date()}
          setCurrentDate={setSelectDay}
          todoList={todoList}
          setTodoList={setTodoList}
          userNo={userInfo['id']}
          userRelation={todoListRelation}
          onEdit={handleEditResult}
          onDeleteResult={handleDeleteTodoList}
          isLoading={isTodoListLoading}
          isLoadingEnd={isTodoListLoadingEnd}
          setCurrTask={setCurrTask}
          updateTasks={updateTasks}
        />
        <CreateRoutineBtn to={`/routine/list`}>
          <CreateRoutineIconWrapper>
            <CreateRoutineIcon src={addRoutineBtn} />
          </CreateRoutineIconWrapper>
          <div style={{ color: '#7F7F7F', fontSize: 'calc(100vw * (10 / 375))' }}>루틴</div>
        </CreateRoutineBtn>
      </React.Fragment>,
    ]
  }
  return (
    <>
      <TodolistPageInner>
        <div
          style={{
            zIndex: 500,
            maxHeight: `${currBar === 'calendar' ? '0' : '300px'}`,
            transition: `${
              currBar === 'calendar' ? 'all 0.5s cubic-bezier(0, 1, 0, 1)' : 'all 0.5s'
            }`,
            overflow: `${currBar === 'calendar' ? 'hidden' : 'visible'}`,
            flex: `0 1 auto`,
            flexDirection: 'column',
          }}
          onTransitionEnd={(e) => {
            e.persist()
            if (currBar === 'calendar') {
              setDisplayCalendar(true)
            }
          }}
        >
          <div>
            <MyTaskListHeader
              name={userInfo.name}
              achievementGoal={userdata.achievement_goal}
              userImg={userdata.profile_img}
            />
          </div>
          <div
            style={{
              marginBottom: 'calc(100vw*(22/375)',
              padding: '0 calc(100vw * (17 / 375))',
            }}
          >
            <AchivementBlock
              userNo={userInfo['id']}
              reloadData={reloadAchivement}
              setReloadData={setReloadAchivement}
            />
          </div>
        </div>
        <div style={{ zIndex: 510, flex: `1 1 auto` }}>
          <TaskListNavBar
            itemList={navBarList}
            onSelect={(selectedIndex) => {
              const newNavBarList = navBarList.slice()
              for (let i = 0; i < newNavBarList.length; ++i) {
                if (selectedIndex === i) {
                  newNavBarList[i]['currTab'] = true
                  setCurrBar(newNavBarList[i]['data'])
                } else {
                  newNavBarList[i]['currTab'] = false
                }
              }
              setNavBarList(newNavBarList)
            }}
          />
        </div>
        <div
          style={{
            zIndex: 510,
            flex: '1 1 auto',
            background: 'white',
            overflow: 'hidden',
            height: '100%',
          }}
        >
          {currSelectedData}
        </div>
      </TodolistPageInner>
    </>
  )
}

const TodolistPageInner = styled.div`
  background: #fffbf0;
  overflow: hidden;
  height: 100%;
  display: -webkit-flex;
  -webkit-flex-flow: column;
`

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  // padding-bottom: calc(100vw * (31 / 375));
`

const TodoListWrapper = styled.div`
  position: absolute;
  top: ${({ isOpen }) => (isOpen ? '0' : '100%')};
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  height: 100%;
  background: #f7f7f7;
  overflow: hidden;
  transition: all 0.2s linear;
`

const TodoListHeader = styled.div`
  padding: calc(100vw * (13 / 375)) calc(100vw * (27 / 375)) 0;
  flex: 1 1 auto;
`

const TodoListCloseBtnBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: calc(100vw * (13.9 / 375));
`

const TodoListCloseBtn = styled.button`
  width: calc(100vw * (24.6 / 375));
  height: calc(100vw * (6.1 / 375));
`

const TodoListCloseBtnImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const TodoListHeaderTxt = styled.div`
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #121212;
  font-weight: 700;
`

const CreateRoutineBtn = styled(Link)`
  position: fixed;
  width: calc(100vw * (58 / 375));
  height: calc(100vw * (58 / 375));
  background: #fff;
  right: calc(100vw * (18 / 375));
  bottom: calc(100vw * (80 / 375));
  border: 1px solid #eaeaea;
  border-radius: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (10 / 375));
  text-align: center;
  filter: drop-shadow(0px 0px 20px rgba(191, 191, 191, 0.5));
`
const CreateRoutineIconWrapper = styled.div`
  width: calc(100vw * (24 / 375));
  height: calc(100vw * (24 / 375));
  margin-bottom: calc(100vw * (5 / 375));
`
const CreateRoutineIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
